<template>
  <div class="container">
    <el-table
      :data="items"
      style="width: 100%;"
      max-height="100%">
      <el-table-column
        prop="name"
        label="姓名"
        width="100">
      </el-table-column>
      <el-table-column
        prop="phoneNum"
        label="手机号"
        width="120">
      </el-table-column>
      <el-table-column
        label="状态"
        prop="status"
        width="100"
      >
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            active-text="已拨"
            active-color="#00923f"
            active-text-color="#00923f"
            @change="changeState(scope.row)">
          </el-switch>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { editStatus, getMobiles } from '@/api/interface'
export default {
  name: 'MobilesView',
  data () {
    return {
      items: []
    }
  },
  created () {
    this.getMobileList()
  },
  methods: {
    async getMobileList () {
      const { data } = await getMobiles()
      this.items = data
      // console.log(data)
    },
    async changeState (row) {
      const data = { phoneNum: row.phoneNum }
      await editStatus(data)
    }
  }
}

</script>

<style lang="scss" scoped>
.container {
  margin-top: 1.25rem;
}
.el-table__body-wrapper {
  max-height: 100%;
}

</style>
